export default __webpack_public_path__ + "static/media/item-cover.06ac88e3.png";